import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Stopwatch(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Stopwatch", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M11.804 16.492a.688.688 0 0 1-.486-.202l-4.125-4.125a.687.687 0 0 1 .972-.972l4.125 4.125a.687.687 0 0 1-.486 1.174Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M6.002 15a1.002 1.002 0 0 1-.709-1.71l4.009-4.01a1.002 1.002 0 0 1 1.417 1.417L6.71 14.706a1.002 1.002 0 0 1-.708.294Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M34.687 17.492a.688.688 0 0 1-.486-1.174l4.125-4.125a.688.688 0 0 1 .972.972l-4.125 4.125a.687.687 0 0 1-.486.202Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M41.165 15a.835.835 0 0 1-.59-.245l-3.34-3.34a.835.835 0 0 1 1.18-1.18l3.34 3.34a.835.835 0 0 1-.59 1.425Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M27.313 5.375h-6.875v5.5h6.875v-5.5Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M27.313 4h-6.875a1.375 1.375 0 1 0 0 2.75h6.875a1.375 1.375 0 1 0 0-2.75Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M23.875 43.875c9.492 0 17.188-7.695 17.188-17.188 0-9.492-7.696-17.187-17.188-17.187-9.492 0-17.188 7.695-17.188 17.188 0 9.492 7.696 17.187 17.188 17.187Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M23.875 40.438c7.594 0 13.75-6.157 13.75-13.75 0-7.594-6.156-13.75-13.75-13.75s-13.75 6.156-13.75 13.75c0 7.593 6.156 13.75 13.75 13.75Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "m25.938 28.041-1.396-5.637a.687.687 0 0 0-1.334 0l-1.395 5.637a2.062 2.062 0 0 0 4.125 0Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M23.889 28.75a.687.687 0 1 0 0-1.375.687.687 0 0 0 0 1.375Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M23.875 37.688a.687.687 0 0 1-.688-.688v-1.375a.687.687 0 1 1 1.375 0V37a.687.687 0 0 1-.687.688Zm7.292-3.021a.687.687 0 0 1-.486-.202l-.973-.971a.688.688 0 0 1 .973-.973l.972.973a.687.687 0 0 1-.486 1.173Zm-14.584 0a.687.687 0 0 1-.486-1.174l.972-.972a.688.688 0 1 1 .973.973l-.973.971a.687.687 0 0 1-.486.202Zm7.292-16.23a.687.687 0 0 1-.688-.687v-1.375a.687.687 0 1 1 1.375 0v1.375a.687.687 0 0 1-.687.688Zm10.313 8.938h-1.376a.687.687 0 1 1 0-1.375h1.376a.687.687 0 1 1 0 1.375Zm-19.25 0h-1.376a.687.687 0 1 1 0-1.375h1.376a.687.687 0 1 1 0 1.375Zm15.257-6.32a.688.688 0 0 1-.487-1.173l.973-.972a.686.686 0 0 1 1.133.748.688.688 0 0 1-.161.223l-.972.973a.689.689 0 0 1-.486.201Zm-12.64 0a.688.688 0 0 1-.486-.2l-.972-.974a.688.688 0 1 1 .972-.971l.973.971a.688.688 0 0 1-.487 1.174Z"
      }
    )
  ] });
}
Stopwatch.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Stopwatch"
};
validateTidalLicense();
export {
  Stopwatch
};
//# sourceMappingURL=Stopwatch.js.map
